import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'didStatus' })
export class DidStatusPipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(value): string {
    const token = `common.did-statuses.${value.replaceAll('_', '-').toLowerCase()}`
    return this.translate.instant(token).toUpperCase();
  }
}
